// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconClock = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M12.25 1C6.05 1 1 6.05 1 12.25S6.05 23.5 12.25 23.5 23.5 18.45 23.5 12.25 18.46 1 12.25 1zm0 21c-5.38 0-9.75-4.37-9.75-9.75S6.87 2.5 12.25 2.5 22 6.87 22 12.25 17.63 22 12.25 22zm5.22-5.59c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-4.69-4.69a.776.776 0 01-.22-.53V8.5c0-.41.34-.75.75-.75s.75.34.75.75v3.44l4.47 4.47z"
      fill="currentColor"
    />
  );
export default SvgIconClock;
